import { render } from "./PlaceholderParagraph.vue?vue&type=template&id=e64c8462&ts=true"
import script from "./PlaceholderParagraph.vue?vue&type=script&lang=ts"
export * from "./PlaceholderParagraph.vue?vue&type=script&lang=ts"

import "./PlaceholderParagraph.vue?vue&type=style&index=0&id=e64c8462&lang=scss"

import exportComponent from "/home/node/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__